import React from "react";
import moment, { Moment } from "moment-timezone";

interface PlayerInjuryProps {
  name: string;
  position: string;
  newsTitle: string;
  newsTime: Moment;
}

const PlayerInjury = (props: PlayerInjuryProps) => {
  let { name, position, newsTitle, newsTime } = props;
  return (
    <div className="games-table-column__injury_container">
      <p className="games-table-column__injury-text">
        <span className="games-table-column__injury-text--bold">
          {position} {name}
        </span>
        {newsTitle ? ` - ${newsTitle}` : ""}
      </p>
      <p className="games-table-column__injury-date-text">
        {newsTime ? moment(newsTime).format("MMM DD - hh:mm a") : ""}
      </p>
    </div>
  );
};

export default PlayerInjury;
